import request from '@/utils/request'

/**
 *合箱
 * @param {*} data 
 */
export function combinedBox(data){
    return request({
        url: '/box/combinedBox',
        method: 'post',
        data
    })
}

/**
 *已合箱列表
 * @param {*} data 
 */
 export function boxList(data){
    return request({
        url: '/box/boxList',
        method: 'post',
        data
    })
}

/**
 *合箱-出库/分拨中心出库
 * @param {*} data 
 */
 export function boxDelivery(data){
    return request({
        url: '/box/delivery',
        method: 'post',
        data
    })
}


/**
 *合箱-查看详情
 * @param {*} data 
 */
 export function boxDetails(data){
    return request({
        url: '/box/boxDetails',
        method: 'post',
        data
    })
}

/**
 *合箱-面单
 * @param {*} data  boxId
 */
 export function faceSheet(data){
    return request({
        url: '/box/faceSheet',
        method: 'post',
        data
    })
}

/**
 *分拨-派送签收入库
 * @param {*} data 
 */
 export function allocationCentrePut(data){
    return request({
        url: '/allocationCentre/put',
        method: 'post',
        data
    })
}

/**
 *分拨-派送签收入库信息
 * @param {*} data 
 */
 export function allocationCentreInformation(data){
    return request({
        url: '/allocationCentre/information',
        method: 'post',
        data
    })
}

/**
 *派送出库面单
 * @param {*} data 
 */
 export function settlementSheet(data){
    return request({
        url: '/allocationCentre/settlementSheet',
        method: 'post',
        data
    })
}
/**
 *预约提醒按钮
 * @param {*} data 
 */
 export function setReservation(data){
    return request({
        url: '/appoint/reservation',
        method: 'post',
        data
    })
}

/**
 *派送出库结算
 * @param {*} data 
 */
 export function confirmSettlement(data){
    return request({
        url: '/allocationCentre/confirmSettlement',
        method: 'post',
        data
    })
}

/**
 *派送批量已入库出库结算
 * @param {*} data 
 */
 export function deliverOutTopay(data){
    return request({
        url: '/allocationCentre/batchConfirmSettlement',
        method: 'post',
        data
    })
}

/**
 *批量出库
 * @param {*} data 
 */
 export function volumeDelivery(data){
    return request({
        url: '/box/volumeDelivery',
        method: 'post',
        data
    })
}
/**
 *撤销合箱
 * @param {*} data 
 */
 export function cancelBox(data){
    return request({
        url: '/box/unPacking',
        method: 'post',
        data
    })
}

/**
 *派送批量入库
 * @param {*} data 
 */
 export function multiIntoStore(data){
    return request({
        url: '/allocationCentre/batchPut',
        method: 'post',
        data
    })
}


/**
 * 中心仓库批量入库
 * @param {*} data 
 */
 export function mulIntoStore(data){
    return request({
        url: '/box/batchEnter',
        method: 'post',
        data
    })
}

/**
 * 派送已入库批量出库结算
 * @param {*} data 
 */
 export function mulOutStoreToPay(data){
    return request({
        url: '/allocationCentre/batchSettlementBySendId',
        method: 'post',
        data
    })
}

/**
 * Excel批量合箱
 * @param {*} file Excel文件
 */
export function excelBatchBoxing(file){
    const formData = new FormData();
    formData.append('file', file);
    
    return request({
        url: '/box/excelBatchBoxing',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/box.js